// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organization-settings-page {
  box-sizing: border-box;
  width: min(var(--app-shell-max-width), calc(100vw - (var(--app-shell-gutter) * 2)));
  margin-inline: auto;
  min-height: calc(100vh - 56px);
  padding-top: 1px;
  background: #f7f9fc;
  text-align: left;
}

.organization-settings-layout {
  display: flex;
  align-items: flex-start;
  gap: 40px;
  box-sizing: border-box;
  width: 100%;
  padding: 32px 0 40px 0;
}

.organization-settings-nav {
  width: 200px;
  flex-shrink: 0;
  padding-top: 4px;
}

.organization-settings-nav-button {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin-bottom: 6px;
  padding: 9px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #475569;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease;
}

.organization-settings-nav-button:hover,
.organization-settings-nav-button:focus {
  background: #eef2f7;
  outline: none;
}

.organization-settings-nav-button.active {
  background: #e8eefc;
  color: #2f6dd0;
}

.organization-settings-nav-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.organization-settings-main {
  flex: 1 1;
  min-width: 0;
  max-width: 760px;
}

.organization-settings-main.api-keys-main {
  max-width: none;
}

.organization-settings-hero {
  margin: 0 0 22px;
}

.organization-settings-title {
  margin: 0;
  color: #0f172a;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.2;
}

.organization-settings-description {
  margin: 8px 0 0;
  color: #6b7280;
  font-size: 14px;
}

.organization-settings-name {
  color: #475569;
  font-weight: 600;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}

/* Card */
.org-card {
  border: 1px solid #e6edf7;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(31, 41, 55, 0.04);
  overflow: hidden;
}

.org-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 24px 28px;
  border-bottom: 1px solid #eef2f7;
}

.org-card-title {
  margin: 0;
  color: #0f172a;
  font-size: 22px;
  font-weight: 800;
}

.org-card-subtitle {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 13px;
  max-width: 360px;
}

.org-saved-badge {
  flex-shrink: 0;
  padding: 4px 12px;
  border-radius: 999px;
  background: #e7f6ec;
  color: #2f8f4e;
  font-size: 12px;
  font-weight: 600;
}

.org-card-body {
  padding: 22px 28px 8px;
}

.org-api-keys-layout {
  display: grid;
  grid-template-columns: minmax(0, 760px) 360px;
  gap: 28px;
  align-items: start;
}

.org-api-keys-form {
  min-width: 0;
}

.org-api-keys-guide {
  padding: 18px;
  border: 1px solid #e6edf7;
  border-radius: 14px;
  background: #f8fafc;
}

.org-guide-section + .org-guide-section {
  margin-top: 18px;
}

.org-guide-section h3 {
  margin: 0 0 10px;
  color: #1f2937;
  font-size: 14px;
  font-weight: 700;
}

.org-guide-section ol {
  margin: 0;
  padding-left: 18px;
}

.org-guide-section li,
.org-guide-section p {
  margin: 0 0 10px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.6;
}

.org-guide-section code {
  display: block;
  margin-top: 4px;
  padding: 6px 8px;
  border-radius: 6px;
  background: #eef2f7;
  color: #334155;
  font-size: 11px;
  overflow-wrap: anywhere;
}

.org-section {
  margin-top: 18px;
}

.org-section-eyebrow {
  margin-bottom: 12px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

/* Toggle row */
.org-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.org-toggle-title {
  margin: 0;
  color: #1f2937;
  font-size: 14px;
  font-weight: 700;
}

.org-toggle-desc {
  margin: 2px 0 0;
  color: #6b7280;
  font-size: 13px;
}

.org-switch {
  position: relative;
  flex-shrink: 0;
  width: 42px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: #d8dee9;
  cursor: pointer;
  transition: background 180ms ease;
}

.org-switch.on {
  background: #93b4f5;
}

.org-switch-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  transition: left 180ms ease;
}

.org-switch.on .org-switch-knob {
  left: 20px;
}

/* Fields */
.org-field-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 14px;
}

.org-field-row.two-col {
  grid-template-columns: 1fr 1fr;
}

.org-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.org-field-label {
  margin-bottom: 6px;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.org-field-input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #d8e0ec;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.org-field-input:focus {
  outline: none;
  border-color: #6f9af0;
  box-shadow: 0 0 0 3px rgba(111, 154, 240, 0.15);
}

/* Count badge */
.org-count-badge {
  flex-shrink: 0;
  padding: 4px 12px;
  border-radius: 999px;
  background: #eef2f7;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
}

/* Members */
.org-members-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.org-members-toolbar-left {
  display: flex;
  gap: 10px;
}

.org-member-list {
  display: flex;
  flex-direction: column;
}

.org-member-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px 10px;
  border-bottom: 1px solid #eef2f7;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 700;
}

.org-member-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 4px;
  border-bottom: 1px solid #f1f5f9;
}

.org-member-row:last-child {
  border-bottom: none;
}

.org-member-identity {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.org-member-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #e8eefc;
  color: #2f6dd0;
  font-size: 14px;
  font-weight: 700;
}

.org-member-email {
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.org-member-role {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}

.org-role-badge {
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.org-role-badge.organizer {
  background: #e7f6ec;
  color: #2f8f4e;
}

.org-role-badge.regular {
  background: #eef2f7;
  color: #475569;
}

.org-member-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.org-link-btn {
  border: none;
  background: transparent;
  padding: 0;
  color: #2f6dd0;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.org-link-btn.danger {
  color: #d14343;
}

.org-link-btn:hover {
  text-decoration: underline;
}

.org-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease;
}

.org-icon-btn:hover {
  background: #fde8e8;
  color: #d14343;
}

.org-btn-danger {
  border: 1px solid #f0c2c2;
  background: #fff;
  color: #d14343;
}

.org-btn-danger:hover:not(:disabled) {
  background: #fdf0f0;
}

.org-dot-icon {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1.5px solid #94a3b8;
}

/* Footer */
.org-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 8px;
  padding: 16px 28px;
  border-top: 1px solid #eef2f7;
  background: #fafbfd;
}

.org-footer-note {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #94a3b8;
  font-size: 13px;
}

.org-lock-icon {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  border: 1.5px solid #94a3b8;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.org-footer-actions {
  display: flex;
  gap: 10px;
}

.org-btn {
  padding: 9px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 160ms ease, border-color 160ms ease, opacity 160ms ease;
}

.org-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.org-btn-secondary {
  border: 1px solid #d8e0ec;
  background: #fff;
  color: #334155;
}

.org-btn-secondary:hover:not(:disabled) {
  background: #f1f5f9;
}

.org-btn-primary {
  border: 1px solid #111827;
  background: #111827;
  color: #fff;
}

.org-btn-primary:hover:not(:disabled) {
  background: #1f2937;
}

/* Invite modal */
.org-invite-modal .modal-content {
  border: none;
  border-radius: 16px;
  background: transparent;
  box-shadow: none;
}

.org-invite-card {
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
  overflow: hidden;
  text-align: left;
}

.org-invite-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #eef2f7;
}

.org-invite-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.org-invite-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 9px;
  background: #e8eefc;
  color: #2f6dd0;
}

.org-invite-title {
  margin: 0;
  color: #0f172a;
  font-size: 17px;
  font-weight: 700;
}

.org-invite-org {
  padding: 2px 8px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #334155;
  font-size: 14px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}

.org-invite-close {
  border: none;
  background: transparent;
  color: #94a3b8;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.org-invite-close:hover {
  color: #475569;
}

.org-invite-body {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 22px 24px;
}

.org-invite-hint {
  margin-top: 6px;
  color: #94a3b8;
  font-size: 12px;
}

.org-invite-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid #eef2f7;
  background: #fafbfd;
}

.org-invite-submit {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 768px) {
  .organization-settings-layout {
    flex-direction: column;
    gap: 16px;
    padding: 16px 0 28px;
  }

  .organization-settings-nav {
    width: 100%;
  }

  .org-api-keys-layout {
    grid-template-columns: 1fr;
  }

  .org-field-row.two-col {
    grid-template-columns: 1fr;
  }

  .organization-settings-main,
  .organization-settings-main.api-keys-main,
  .org-card,
  .org-api-keys-layout,
  .org-api-keys-form {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }

  .organization-settings-title {
    font-size: 24px;
  }

  .org-card-header,
  .org-card-footer,
  .org-members-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .org-card-header,
  .org-card-body,
  .org-card-footer {
    padding-left: 18px;
    padding-right: 18px;
  }

  .org-member-head {
    display: none;
  }

  .org-member-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }

  .org-member-identity,
  .org-member-role,
  .org-member-actions {
    width: 100%;
  }

  .org-member-role {
    justify-content: space-between;
  }

  .org-member-actions {
    justify-content: flex-end;
  }

  .org-members-toolbar-left,
  .org-footer-actions {
    flex-wrap: wrap;
  }

  .org-members-toolbar-left {
    width: 100%;
  }

  .org-members-toolbar .org-btn {
    width: 100%;
    flex: 0 0 auto;
  }

  .org-footer-actions .org-btn {
    flex: 1 1 140px;
  }
}

/* Admin: reassign dataset organization */
.reassign-org-panel {
  margin-top: 16px;
  padding: 16px 0 24px;
  text-align: left;
}

.reassign-org-hero {
  margin-bottom: 16px;
}

.reassign-org-title {
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.reassign-org-desc {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.45;
}

.reassign-org-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}

.reassign-org-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.reassign-org-field select,
.reassign-org-field input {
  min-height: 36px;
  padding: 6px 10px;
  border: 1px solid #d8e0ec;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  font-size: 13px;
  font-weight: 500;
}

.reassign-org-search {
  min-width: 200px;
  flex: 1 1;
}

.reassign-org-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.reassign-org-table-wrap {
  max-height: 420px;
  overflow: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

.reassign-org-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.reassign-org-table th,
.reassign-org-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #eef2f7;
  text-align: left;
  white-space: nowrap;
}

.reassign-org-table th {
  position: sticky;
  top: 0;
  background: #f8fafc;
  color: #475569;
  font-weight: 700;
  z-index: 1;
}

.reassign-org-empty {
  padding: 24px;
  color: #64748b;
  font-size: 13px;
}

.reassign-org-result {
  margin-top: 12px;
  max-height: 240px;
  overflow: auto;
  padding: 12px;
  border-radius: 8px;
  background: #0f172a;
  color: #e2e8f0;
  font-size: 12px;
  line-height: 1.4;
}

/* Admin: per-organization training defaults */
.org-train-defaults {
  max-width: 880px;
  padding: 16px 0 24px;
  text-align: left;
}

.org-train-json-field {
  margin-top: 18px;
}

.org-train-json-editor {
  width: 100%;
  min-height: 380px;
  padding: 14px;
  box-sizing: border-box;
  resize: vertical;
  border: 1px solid #d8e0ec;
  border-radius: 8px;
  background: #0f172a;
  color: #e2e8f0;
  font: 13px/1.55 ui-monospace, SFMono-Regular, Menlo, monospace;
  tab-size: 2;
}

.org-train-json-editor:focus {
  outline: none;
  border-color: #6f9af0;
  box-shadow: 0 0 0 3px rgba(111, 154, 240, 0.15);
}

.org-train-error {
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid #f0c2c2;
  border-radius: 8px;
  background: #fdf0f0;
  color: #b42318;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Auth/OrganizationPage/OrganizationPage.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mFAAmF;EACnF,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA,SAAS;AACT;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;;IAKE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,8DAA8D;EAC9D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".organization-settings-page {\n  box-sizing: border-box;\n  width: min(var(--app-shell-max-width), calc(100vw - (var(--app-shell-gutter) * 2)));\n  margin-inline: auto;\n  min-height: calc(100vh - 56px);\n  padding-top: 1px;\n  background: #f7f9fc;\n  text-align: left;\n}\n\n.organization-settings-layout {\n  display: flex;\n  align-items: flex-start;\n  gap: 40px;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 32px 0 40px 0;\n}\n\n.organization-settings-nav {\n  width: 200px;\n  flex-shrink: 0;\n  padding-top: 4px;\n}\n\n.organization-settings-nav-button {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  margin-bottom: 6px;\n  padding: 9px 12px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n  transition: background 160ms ease, color 160ms ease;\n}\n\n.organization-settings-nav-button:hover,\n.organization-settings-nav-button:focus {\n  background: #eef2f7;\n  outline: none;\n}\n\n.organization-settings-nav-button.active {\n  background: #e8eefc;\n  color: #2f6dd0;\n}\n\n.organization-settings-nav-icon {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.organization-settings-main {\n  flex: 1;\n  min-width: 0;\n  max-width: 760px;\n}\n\n.organization-settings-main.api-keys-main {\n  max-width: none;\n}\n\n.organization-settings-hero {\n  margin: 0 0 22px;\n}\n\n.organization-settings-title {\n  margin: 0;\n  color: #0f172a;\n  font-size: 30px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.organization-settings-description {\n  margin: 8px 0 0;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.organization-settings-name {\n  color: #475569;\n  font-weight: 600;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n\n/* Card */\n.org-card {\n  border: 1px solid #e6edf7;\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 12px 30px rgba(31, 41, 55, 0.04);\n  overflow: hidden;\n}\n\n.org-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 24px 28px;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.org-card-title {\n  margin: 0;\n  color: #0f172a;\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.org-card-subtitle {\n  margin: 4px 0 0;\n  color: #6b7280;\n  font-size: 13px;\n  max-width: 360px;\n}\n\n.org-saved-badge {\n  flex-shrink: 0;\n  padding: 4px 12px;\n  border-radius: 999px;\n  background: #e7f6ec;\n  color: #2f8f4e;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.org-card-body {\n  padding: 22px 28px 8px;\n}\n\n.org-api-keys-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 760px) 360px;\n  gap: 28px;\n  align-items: start;\n}\n\n.org-api-keys-form {\n  min-width: 0;\n}\n\n.org-api-keys-guide {\n  padding: 18px;\n  border: 1px solid #e6edf7;\n  border-radius: 14px;\n  background: #f8fafc;\n}\n\n.org-guide-section + .org-guide-section {\n  margin-top: 18px;\n}\n\n.org-guide-section h3 {\n  margin: 0 0 10px;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.org-guide-section ol {\n  margin: 0;\n  padding-left: 18px;\n}\n\n.org-guide-section li,\n.org-guide-section p {\n  margin: 0 0 10px;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.6;\n}\n\n.org-guide-section code {\n  display: block;\n  margin-top: 4px;\n  padding: 6px 8px;\n  border-radius: 6px;\n  background: #eef2f7;\n  color: #334155;\n  font-size: 11px;\n  overflow-wrap: anywhere;\n}\n\n.org-section {\n  margin-top: 18px;\n}\n\n.org-section-eyebrow {\n  margin-bottom: 12px;\n  color: #94a3b8;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n/* Toggle row */\n.org-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.org-toggle-title {\n  margin: 0;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.org-toggle-desc {\n  margin: 2px 0 0;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.org-switch {\n  position: relative;\n  flex-shrink: 0;\n  width: 42px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  background: #d8dee9;\n  cursor: pointer;\n  transition: background 180ms ease;\n}\n\n.org-switch.on {\n  background: #93b4f5;\n}\n\n.org-switch-knob {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  transition: left 180ms ease;\n}\n\n.org-switch.on .org-switch-knob {\n  left: 20px;\n}\n\n/* Fields */\n.org-field-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.org-field-row.two-col {\n  grid-template-columns: 1fr 1fr;\n}\n\n.org-field {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.org-field-label {\n  margin-bottom: 6px;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.org-field-input {\n  width: 100%;\n  padding: 9px 12px;\n  border: 1px solid #d8e0ec;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  font-size: 14px;\n  box-sizing: border-box;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.org-field-input:focus {\n  outline: none;\n  border-color: #6f9af0;\n  box-shadow: 0 0 0 3px rgba(111, 154, 240, 0.15);\n}\n\n/* Count badge */\n.org-count-badge {\n  flex-shrink: 0;\n  padding: 4px 12px;\n  border-radius: 999px;\n  background: #eef2f7;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* Members */\n.org-members-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.org-members-toolbar-left {\n  display: flex;\n  gap: 10px;\n}\n\n.org-member-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.org-member-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 4px 10px;\n  border-bottom: 1px solid #eef2f7;\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.org-member-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 4px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.org-member-row:last-child {\n  border-bottom: none;\n}\n\n.org-member-identity {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.org-member-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: #e8eefc;\n  color: #2f6dd0;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.org-member-email {\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.org-member-role {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-shrink: 0;\n}\n\n.org-role-badge {\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.org-role-badge.organizer {\n  background: #e7f6ec;\n  color: #2f8f4e;\n}\n\n.org-role-badge.regular {\n  background: #eef2f7;\n  color: #475569;\n}\n\n.org-member-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.org-link-btn {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: #2f6dd0;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.org-link-btn.danger {\n  color: #d14343;\n}\n\n.org-link-btn:hover {\n  text-decoration: underline;\n}\n\n.org-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 160ms ease, color 160ms ease;\n}\n\n.org-icon-btn:hover {\n  background: #fde8e8;\n  color: #d14343;\n}\n\n.org-btn-danger {\n  border: 1px solid #f0c2c2;\n  background: #fff;\n  color: #d14343;\n}\n\n.org-btn-danger:hover:not(:disabled) {\n  background: #fdf0f0;\n}\n\n.org-dot-icon {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  border: 1.5px solid #94a3b8;\n}\n\n/* Footer */\n.org-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 8px;\n  padding: 16px 28px;\n  border-top: 1px solid #eef2f7;\n  background: #fafbfd;\n}\n\n.org-footer-note {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.org-lock-icon {\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n  border: 1.5px solid #94a3b8;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n}\n\n.org-footer-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.org-btn {\n  padding: 9px 18px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 160ms ease, border-color 160ms ease, opacity 160ms ease;\n}\n\n.org-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.org-btn-secondary {\n  border: 1px solid #d8e0ec;\n  background: #fff;\n  color: #334155;\n}\n\n.org-btn-secondary:hover:not(:disabled) {\n  background: #f1f5f9;\n}\n\n.org-btn-primary {\n  border: 1px solid #111827;\n  background: #111827;\n  color: #fff;\n}\n\n.org-btn-primary:hover:not(:disabled) {\n  background: #1f2937;\n}\n\n/* Invite modal */\n.org-invite-modal .modal-content {\n  border: none;\n  border-radius: 16px;\n  background: transparent;\n  box-shadow: none;\n}\n\n.org-invite-card {\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);\n  overflow: hidden;\n  text-align: left;\n}\n\n.org-invite-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 20px 24px;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.org-invite-heading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.org-invite-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: 9px;\n  background: #e8eefc;\n  color: #2f6dd0;\n}\n\n.org-invite-title {\n  margin: 0;\n  color: #0f172a;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.org-invite-org {\n  padding: 2px 8px;\n  border-radius: 6px;\n  background: #f1f5f9;\n  color: #334155;\n  font-size: 14px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n\n.org-invite-close {\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.org-invite-close:hover {\n  color: #475569;\n}\n\n.org-invite-body {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  padding: 22px 24px;\n}\n\n.org-invite-hint {\n  margin-top: 6px;\n  color: #94a3b8;\n  font-size: 12px;\n}\n\n.org-invite-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 24px;\n  border-top: 1px solid #eef2f7;\n  background: #fafbfd;\n}\n\n.org-invite-submit {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n@media (max-width: 768px) {\n  .organization-settings-layout {\n    flex-direction: column;\n    gap: 16px;\n    padding: 16px 0 28px;\n  }\n\n  .organization-settings-nav {\n    width: 100%;\n  }\n\n  .org-api-keys-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .org-field-row.two-col {\n    grid-template-columns: 1fr;\n  }\n\n  .organization-settings-main,\n  .organization-settings-main.api-keys-main,\n  .org-card,\n  .org-api-keys-layout,\n  .org-api-keys-form {\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .organization-settings-title {\n    font-size: 24px;\n  }\n\n  .org-card-header,\n  .org-card-footer,\n  .org-members-toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .org-card-header,\n  .org-card-body,\n  .org-card-footer {\n    padding-left: 18px;\n    padding-right: 18px;\n  }\n\n  .org-member-head {\n    display: none;\n  }\n\n  .org-member-row {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .org-member-identity,\n  .org-member-role,\n  .org-member-actions {\n    width: 100%;\n  }\n\n  .org-member-role {\n    justify-content: space-between;\n  }\n\n  .org-member-actions {\n    justify-content: flex-end;\n  }\n\n  .org-members-toolbar-left,\n  .org-footer-actions {\n    flex-wrap: wrap;\n  }\n\n  .org-members-toolbar-left {\n    width: 100%;\n  }\n\n  .org-members-toolbar .org-btn {\n    width: 100%;\n    flex: 0 0 auto;\n  }\n\n  .org-footer-actions .org-btn {\n    flex: 1 1 140px;\n  }\n}\n\n/* Admin: reassign dataset organization */\n.reassign-org-panel {\n  margin-top: 16px;\n  padding: 16px 0 24px;\n  text-align: left;\n}\n\n.reassign-org-hero {\n  margin-bottom: 16px;\n}\n\n.reassign-org-title {\n  margin: 0 0 6px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.reassign-org-desc {\n  margin: 0;\n  font-size: 13px;\n  color: #64748b;\n  line-height: 1.45;\n}\n\n.reassign-org-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.reassign-org-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 140px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.reassign-org-field select,\n.reassign-org-field input {\n  min-height: 36px;\n  padding: 6px 10px;\n  border: 1px solid #d8e0ec;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.reassign-org-search {\n  min-width: 200px;\n  flex: 1;\n}\n\n.reassign-org-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.reassign-org-table-wrap {\n  max-height: 420px;\n  overflow: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.reassign-org-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.reassign-org-table th,\n.reassign-org-table td {\n  padding: 8px 10px;\n  border-bottom: 1px solid #eef2f7;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.reassign-org-table th {\n  position: sticky;\n  top: 0;\n  background: #f8fafc;\n  color: #475569;\n  font-weight: 700;\n  z-index: 1;\n}\n\n.reassign-org-empty {\n  padding: 24px;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.reassign-org-result {\n  margin-top: 12px;\n  max-height: 240px;\n  overflow: auto;\n  padding: 12px;\n  border-radius: 8px;\n  background: #0f172a;\n  color: #e2e8f0;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n/* Admin: per-organization training defaults */\n.org-train-defaults {\n  max-width: 880px;\n  padding: 16px 0 24px;\n  text-align: left;\n}\n\n.org-train-json-field {\n  margin-top: 18px;\n}\n\n.org-train-json-editor {\n  width: 100%;\n  min-height: 380px;\n  padding: 14px;\n  box-sizing: border-box;\n  resize: vertical;\n  border: 1px solid #d8e0ec;\n  border-radius: 8px;\n  background: #0f172a;\n  color: #e2e8f0;\n  font: 13px/1.55 ui-monospace, SFMono-Regular, Menlo, monospace;\n  tab-size: 2;\n}\n\n.org-train-json-editor:focus {\n  outline: none;\n  border-color: #6f9af0;\n  box-shadow: 0 0 0 3px rgba(111, 154, 240, 0.15);\n}\n\n.org-train-error {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border: 1px solid #f0c2c2;\n  border-radius: 8px;\n  background: #fdf0f0;\n  color: #b42318;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
